import React from 'react';
import routes from '../../routes';
import Grid from '@material-ui/core/Grid';
import PGEButton from '../pge-button/_PgeButton';
import { Link } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';
import colors from '../../themes/main-colors';
import { Button } from '../../constants';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: '16px',
    padding: '0 16px',
  },
  submit: {
    fontWeight: 600,
    borderRadius: '40px',
    padding: '16px 72px !important',
    '&:hover, &:focus': {
      backgroundColor: (props: RegistrationFormFooterProps) =>
        props.theme === 'Emphasis' ? colors.orange : colors.noirBlurLight,
      borderColor: (props: RegistrationFormFooterProps) =>
        props.theme === 'Emphasis' ? colors.orange : colors.noirBlurLight,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  backLinkDesktop: {
    display: 'inline-block',
    marginRight: 20,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  backLinkMobile: {
    display: 'none',
    margin: 20,
    textAlign: 'center',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
}));

interface RegistrationFormFooterProps {
  nextText: string;
  onNext: () => void;
  backText: string;
  onBack: () => void;
  theme?: Button['Theme'];
}

const RegistrationFormFooter = (props: RegistrationFormFooterProps) => {
  const { nextText, onNext, backText, onBack, theme = 'Primary' } = props;
  const classes = useStyles(props);

  return (
    <Grid
      container
      justify="space-between"
      alignContent="center"
      spacing={2}
      alignItems="center"
      className={classes.container}
    >
      <Link className={classes.backLinkDesktop} onClick={onBack}>
        {backText}
      </Link>
      <PGEButton
        type={'submit'}
        theme={theme}
        className={classes.submit}
        onClick={onNext}
      >
        {nextText}
      </PGEButton>
      <Link className={classes.backLinkMobile} onClick={onBack}>
        {backText}
      </Link>
    </Grid>
  );
};

export default RegistrationFormFooter;
